import React, { useState } from "react";
import { auth, db } from "../firebase-config";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logoHoraeWhite from '../assets/svg/logo-horae-white.svg';
import loginBg from '../assets/svg/login.svg';

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetError, setResetError] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      
      // Recherche du rôle dans la collection "employees"
      const employeesRef = collection(db, "employees");
      const q = query(employeesRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        console.log("👤 Données utilisateur trouvées:", userData);
        
        if (userData.role === "admin") {
          console.log("🚀 Navigation directe vers le dashboard");
          navigate("/admin-dashboard");
        } else {
          console.log("🚀 Navigation directe vers le dashboard");
          navigate("/employee-dashboard");
        }
      } else {
        setError("Utilisateur non trouvé dans la base de données");
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      setError("Email ou mot de passe incorrect");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetError("");
    setResetSuccess(false);
    
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSuccess(true);
      setResetEmail("");
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email de réinitialisation:", error);
      setResetError("Une erreur est survenue. Vérifiez que l'email est correct.");
    }
  };

  return (
    <div className="login-container">
      <img src={loginBg} alt="Fond login" className="login-bg" />
      
      <div className="logo-container">
        <img 
          src={logoHoraeWhite}
          alt="Logo" 
          style={{ 
            width: '100%',
            height: '100%',
            objectFit: 'contain'
          }} 
        />
      </div>
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Connexion</h2>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Mot de passe</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button">
          Se connecter
        </button>
        {error && <p className="error-message">{error}</p>}
        <button 
          type="button" 
          className="forgot-password-link"
          onClick={() => setShowResetModal(true)}
        >
          Mot de passe oublié ?
        </button>
      </form>

      {showResetModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Réinitialisation du mot de passe</h3>
            <form onSubmit={handleResetPassword}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required
                />
              </div>
              {resetError && <p className="error-message">{resetError}</p>}
              {resetSuccess && (
                <p className="success-message">
                  Un email de réinitialisation a été envoyé à votre adresse.
                </p>
              )}
              <div className="modal-buttons">
                <button type="submit" className="reset-button">
                  Envoyer
                </button>
                <button 
                  type="button" 
                  className="cancel-button"
                  onClick={() => {
                    setShowResetModal(false);
                    setResetEmail("");
                    setResetError("");
                    setResetSuccess(false);
                  }}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginPage;
